module.exports = __webpack_public_path__ + "static/media/coffee_girl.b096cec2.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/SHS-ASURION/coffee_girl.svg
// module id = 1391
// module chunks = 0